// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3FqsZ","newsImg":"index-module--newsImg--3znKM"};